import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[slug]/page.tsx");
